import React from "react";
import { Link } from "react-router-dom";

const scrollTop = () => { window.scrollTo({ top: 0, behavior: "smooth" }) }

function SimilarCardAlpha(props) {

  return (
    <>
      <div className="guide-card-alpha">
        <div className="guide-image similar-image">
        <Link to={`/${props.ctype}/${props.short_url}`} onClick={scrollTop}><img src={`https://www.campfr.com/images/courses/${props.image}`} alt={props.title} /></Link>
        </div>
        <div className="guide-content">
          <h4 className="guide-name">{props.title} <strong>{props.tutors}</strong></h4>
        </div>
      </div>
    </>
  );
}

export default SimilarCardAlpha;
